export const dateRange = {
  "type": "string",
  "format": "date-range",
  "title": "Дата"
}